export const useGA4 = false;

export const category = {
  input: "input",
  interaction: "interaction",
  download: "download",
  navigation: "navigation",
  view: "view",
  help: "help",
  error: "error",
};

export const action = {
  searchTheLibrary: "search the library",
  viewEvent: "view event",
  viewHelp: "view help",
  downloadFile: "download file",
  downloadLink: "download link",
  downloadDataDictionary: "download data dictionary",
  navigateToExternalResource: "navigate to external resource",
  error: "error",
};
